import { UserData } from "@/common/account/UserData";
import { parseOptionalDate, parseRequiredDate } from "../misc/utility";

export interface IMeetingMessageResult {
    Id: string;
    RowVersion: string;
    IsPublished: boolean;
    Subject: string;
    Content: string;
    NotificationTimestamp: string;
    CreatedById?: string;
    CreatedTimestamp: string;
    ModifiedById?: string;
    ModifiedTimestamp?: string;
}

export interface IAddMeetingMessage {
    Subject: string;
    Content: string;
    Notify: boolean;
    Publish: boolean;
}

export interface IUpdateMeetingMessage {
    Id: string;
    RowVersion: string;
    Subject: string;
    Content: string;
    Notify: boolean;
    Publish: boolean;
}

export class MeetingMessage {
    Id: string;
    RowVersion: string;
    IsPublished: boolean;
    Subject: string;
    Content: string;
    NotificationTimestamp?: Date;
    CreatedBy?: UserData;
    CreatedTimestamp: Date;
    ModifiedBy?: UserData;
    ModifiedTimestamp?: Date;

    constructor(src: IMeetingMessageResult, users: Map<string, UserData>) {
        this.Id = src.Id;
        this.RowVersion = src.RowVersion;
        this.IsPublished = src.IsPublished;
        this.Subject = src.Subject;
        this.Content = src.Content;
        this.NotificationTimestamp = parseOptionalDate(src.NotificationTimestamp);
        this.CreatedBy = src.CreatedById ? users.get(src.CreatedById) : undefined;
        this.CreatedTimestamp = parseRequiredDate(src.CreatedTimestamp);
        this.ModifiedBy = src.ModifiedById ? users.get(src.ModifiedById) : undefined;
        this.ModifiedTimestamp = parseOptionalDate(src.ModifiedTimestamp);
    }
}